<template>
	<div class="header-container">
		<div class="header">
			<router-link class="logo" :to="{name: 'index'}">
				<img src="@/assets/images/logo.png"/>
			</router-link>
			<vNav/>
		</div>
	</div>
</template>

<script>
import vNav from "./nav.vue";

export default {
	components: {vNav}
};
</script>

<style lang="scss" scoped>
.header-container {
	z-index: 1;
	background-color: $white1;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	height: $header;
	padding: 0 em(27);
	border-bottom: 1px solid #E2E2E2;
	width: 100%;

	.header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: $header;
		@include res(small) {
			height: $headerSmall;
		}
	}

	@include res(small) {
		height: $headerSmall;
	}

	.logo {
		width: em(85);
		flex-shrink: 0;

		img {
			display: block;
		}
	}

	/deep/ {
		.nav {
			display: flex;

			.item {
				margin-left: 2em;
				display: flex;
				align-items: center;

				.icon {
					display: inline-flex;
					margin-right: 0.3em;

					svg {
						$s: 24px;
						width: $s;
						height: $s;
					}
				}

				&.router-link-exact-active .icon svg path {
					fill: #D5D6D8;
				}

				.text {
					font-size: 12px;
					line-height: 14px;

				}
			}
		}
	}
}
</style>
